<template>
  <div class="message-container">
    <div
      v-for="(card,index) in form.cards"
      :key="index"
      class="fieldset"
    >
      <legend>{{ $t('reply.form.card-number',{number:index+1}) }}</legend>
      <reply-card-input
        ref="form"
        v-model="form.cards[index]"
        :component-card="card"
      />
    </div>
    <b-button
      v-if="form.cards && form.cards.length<10"
      variant="success"
      size="sm"
      :class="{'mt-2':(form.cards.length===0)}"
      @click="addMoreSlides"
    >
      <FeatherIcon icon="PlusIcon" />
      {{ $t('reply.form.add_more_card') }}
    </b-button>
  </div>
</template>

<script>
import ReplyCardInput from '@/@bya3/components/inputs/ReplyCardInput'
import { BButton } from 'bootstrap-vue'
import { forEach } from 'lodash'
import ReplyMixin from '../../mixins/reply-mixin'

export default {
  name: 'CardsTemplate',
  components: { ReplyCardInput, BButton },
  mixins: [ReplyMixin],
  mounted() {
    if (!this.form.cards.length) {
      this.addMoreSlides()
    }
  },
  methods: {
    addMoreSlides() {
      this.form.cards.push({
        title: '',
        image_url: '',
        subtitle: '',
        buttons: [],
      })
    },
    remove(index) {
      this.form.cards.splice(index, 1)
    },
    async submit() {
      let valid = true
      forEach(this.$refs.form, async cardForm => {
        if (valid) valid = await cardForm.$refs.form.validate()
      })
      if (!valid) throw new Error(this.$tc('errors.field-invalid', 1))
    },
  },
}
</script>
